const $ = require("jquery");
const JointAnimation = require("./JointAnimation");
const _ = require("lodash");

class JointsBackgroundAnimation {
	constructor (id) {
		this.id = id;

		this.jointAnimation = new JointAnimation(
			this.getJointAnimation().attr("id")
		);

		this.jointAnimation.rotate(
			this.getFirstJointRotation(),
			this.getAnimationType() === "left" ? -90 : 45
		);

		this.lastTimestamp = window.performance.now();
		this.rotationSpeed = 10;
		this.animationFrame(window.performance.now());
	}

	getRoot () {
		return $(`#${this.id}`);
	}

	getJointAnimation () {
		return this.getRoot().find('[data-component=joint-animation]');
	}

	getJointAnimationWrap () {
		return this.getRoot().find('[data-component=joint-animation-wrap]');
	}

	getAnimationType () {
		return this.getRoot().data("animationtype");
	}

	getJointAnimationWrapScreenYPosition () {
		return this.getJointAnimationWrap()[0].getBoundingClientRect().y;
	}

	getScreenHeight () {
		return window.innerHeight;
	}

	getFirstJointRotation () {
		return this.getAnimationType() === "left" ? -45 : 45;
	}

	/* Rotation in degrees */
	rotate (rot) {
		this.jointAnimation.rotate(this.getFirstJointRotation(), rot);
	}

	animationFrame (timestamp) {
		if (!this.lastTimestamp) {
			this.lastTimestamp = timestamp;
		}

		const dt = (this.lastTimestamp - timestamp) / 1000;
		const turn = this.rotationSpeed * dt;

		let rot = 0;

		switch (this.getAnimationType()) {
			case "left": {
				rot = _.clamp(
					-90 + (
						135 - (
							(
								this.getJointAnimationWrapScreenYPosition() +
								this.getScreenHeight()
							) / this.getScreenHeight()
							* 135
						)
					),
					-90,
					45
				);
				break;
			}

			default: {
				rot = _.clamp(
					45 - (
						90 - (
							(
								this.getJointAnimationWrapScreenYPosition() +
								this.getScreenHeight()
							) / this.getScreenHeight()
							* 90
						)
					),
					-45,
					45
				);
			}
		}

		this.rotate(rot);

		this.lastTimestamp = timestamp;

		window.requestAnimationFrame(ts => this.animationFrame(ts));
	}
}

JointsBackgroundAnimation.init = () => {
	const objects = [];

	$('[data-component=joints-background-animation]').each((i, e) => {
		const id = $(e).attr("id");
		objects.push(new JointsBackgroundAnimation(id));
	});

	return objects;
}

module.exports = JointsBackgroundAnimation;
